import { InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';
import { DisputeAgreement, disputeResolutionOptions } from 'src/utils/options';
import { formatDate } from 'src/utils/date';
import { formatNumber } from 'src/utils/utility';
import { useMemo } from 'react';
import { IDisputeFormValues } from './types';
import { SummaryInfo } from './SummaryInfo';
import { UCTCardFile } from '../UploadDocument/CardFile';

interface ISummaryProps {
  invoiceSummary: InvoiceSummaryDto;
  values: IDisputeFormValues;
  isHideHeader?: boolean;
}

export const DisputeSummary: React.FC<ISummaryProps> = (props) => {
  const { invoiceSummary, values, isHideHeader } = props;

  const outcome = useMemo(() => {
    if (values?.agreementType === null || values?.agreementType === 'CANCEL_DISPUTE') {
      return 'Cancel Dispute';
    }
    if (!values?.agreementType) {
      return '';
    }
    return disputeResolutionOptions?.find((v) => v?.id === values?.agreementType)?.label;
  }, [values?.agreementType]);

  // Calculate the display amount based on amountOption
  const displayAmount = useMemo(() => {
    if (values?.agreementType !== DisputeAgreement.ACCEPT_INVOICE_WITH_CREDIT_NOTE) {
      return null;
    }

    // Calculate based on selected option
    if (values?.amountOption === 'FULL_INVOICE') {
      return invoiceSummary?.invoiceAmount?.afterTax;
    } else if (values?.amountOption === 'DEVIATIONS') {
      return invoiceSummary?.invoiceAmountDeviation?.afterTax;
    } else if (values?.amountOption === 'OTHER' && values?.otherAmount) {
      const parsed = parseFloat(values.otherAmount);
      return !isNaN(parsed) ? parsed : null;
    }

    return null;
  }, [values?.agreementType, values?.amountOption, values?.otherAmount, invoiceSummary]);

  return (
    <div className=''>
      {!isHideHeader && (
        <>
          <h3 className='text-16 xl:text-20 leading-20 xl:leading-24 mb-4 font-bold'>Summary</h3>
          <p className='mb-32 xl:mb-40 text-blue_grey-90 text-12 xl:text-14 leading-18'>Here&lsquo;s the dispute summary</p>
        </>
      )}

      <SummaryInfo title='Outcome' value={outcome} />
      <SummaryInfo title='Additional Information' value={values?.reason} />

      {displayAmount !== null && (
        <SummaryInfo title='Total amount of credit note (after tax)' value={`${invoiceSummary?.invoiceDispute?.currency} ${formatNumber(displayAmount)}`} />
      )}

      {invoiceSummary?.invoiceAttachments?.length > 0 && (
        <>
          {invoiceSummary?.invoiceAttachments
            ?.filter((attachment) => attachment?.attachmentType === 'CREDIT_NOTE')
            ?.map((attachment) => (
              <UCTCardFile
                key={attachment.id}
                attachment={attachment}
                name={attachment?.fileName}
                uploadPercentage={100}
                dateInfo={formatDate(new Date(attachment?.createdOn))}
                showDeleteButton={false}
              />
            ))}
        </>
      )}
    </div>
  );
};
